import apiClient from "./client";
import type {
  ConditionGetResponse,
  ConditionMutationResponse,
  ConditionUpdatePayload,
  UpdateConditionOptions,
} from "../types/condition";

export const getCondition = async (): Promise<ConditionGetResponse> => {
  const { data } = await apiClient.get<ConditionGetResponse>("/condition");
  return data;
};

export const updateCondition = async (
  payload: ConditionUpdatePayload,
  options: UpdateConditionOptions = {}
): Promise<ConditionMutationResponse> => {
  const config: { params?: { id: number } } = {};
  if (options.id) {
    config.params = { id: options.id };
  }
  const { data } = await apiClient.put<ConditionMutationResponse>(
    "/condition",
    payload,
    config
  );
  return data;
};
